// ============================================================
// DYNAMIC WEB PARTNERS — styled-components theme
//
// House style: dark & cinematic, but its own identity — a warm
// near-black "backstage" base, a single amber/gold "spotlight"
// accent, expressive Clash Display headings over a clean Satoshi
// body. No mono labels, no hairline ticks.
//
// Consumed via <ThemeProvider theme={theme}> (gatsby-browser.js /
// gatsby-ssr.js). Tokens are also mirrored as CSS custom
// properties in GlobalStyles.js (:root).
// ============================================================

export const theme = {
  color: {
    // surfaces — warm near-black "backstage"
    ink: "#0b0a08", // base background
    inkPure: "#000000", // full-bleed / cinematic
    coal: "#16130d", // raised panel
    smoke: "#221c12", // hover surface
    line: "#2f2718", // soft warm border
    // text
    paper: "#f6f3ea", // warm white
    ash: "#a79d89", // muted warm grey
    faint: "#6f6553", // labels / metadata
    // the one accent — amber "spotlight"
    gold700: "#a86f1f",
    gold500: "#e7a338", // signature amber/gold
    gold400: "#ffc35c", // vivid hover
    glow: "rgba(231, 163, 56, 0.16)", // soft spotlight wash
  },
  font: {
    display: '"Clash Display", "Archivo", system-ui, sans-serif',
    sans: '"Satoshi", "Inter", system-ui, -apple-system, sans-serif',
  },
  text: {
    mega: "clamp(3rem, 9.2vw, 11rem)",
    headline: "clamp(2.25rem, 6vw, 5.75rem)",
    title: "clamp(1.6rem, 3vw, 2.85rem)",
    lead: "clamp(1.1rem, 1.6vw, 1.5rem)",
    kicker: "0.8rem",
  },
  ease: {
    expo: "cubic-bezier(0.16, 1, 0.3, 1)",
    power: "cubic-bezier(0.7, 0, 0.2, 1)",
  },
}

export default theme
